module.exports = __webpack_public_path__ + "a663dd79.webp";